import { Component, OnInit } from '@angular/core';
import { Job } from '@contracts/interfaces/job.interface';
import { JobService } from 'src/app/services/job.service';

@Component({
  selector: 'app-bank-transfer-tests',
  templateUrl: './bank-transfer-tests.component.html',
  styleUrls: ['./bank-transfer-tests.component.scss']
})
export class BankTransferTestsComponent implements OnInit {

  constructor(private jobService: JobService) { }

  ngOnInit(): void {

  }


  doTransfers() {
    console.log("HIT");
    // Source Account
    let sourceAccount = "495280120"; // Cash Revenue
    //let sourceAccount = "480004229"; // Revenue
    //let sourceAccount = "425866854"; // Wages

    
    //let sourceAccount = "443135490"; // BendigoPM

    //let sourceAccount = "453376588" // Jools for Jim
    //let sourceAccount = "452826719" // Weld One
    //let sourceAccount = "426179790" // Carpet Court
    //let sourceAccount = "426409233" // Fresh FM
    //let sourceAccount = "443313997" // Strath Village


    // Dest Account
    //let destAccount = "442829529"; // Expenses
    //let destAccount = "453450661"; // GST
    //let destAccount = "425866854"; // Wages
    let destAccount = "480004229"; // Revenue
    //let destAccount = "426179757"; // Super
    //let destAccount = "416439228"; // payg


    // Cash Reconcile
    this.jobService.create({
      job: Job.BANK_TRANSFER,
      date: {
        start: new Date()
      },
      data: {
        transfers: [
          {
              "srcAccount": "495280120",
              "destAccount": "480004229",
              "amount": "80",
              "transactionDescription": "Inv 2006"
          },
          {
              "srcAccount": "495280120",
              "destAccount": "480004229",
              "amount": "50",
              "transactionDescription": "Inv 2030"
          },
          {
              "srcAccount": "495280120",
              "destAccount": "480004229",
              "amount": "85",
              "transactionDescription": "Inv 1458"
          },
          {
              "srcAccount": "495280120",
              "destAccount": "480004229",
              "amount": "30",
              "transactionDescription": "Inv 2033"
          },
          {
              "srcAccount": "495280120",
              "destAccount": "480004229",
              "amount": "31",
              "transactionDescription": "Inv 2032"
          }
      ]
      }
    }).subscribe(r=> {
      console.log(r);
    })

    // Square Reconcile
    // this.jobService.create({
    //   job: Job.BANK_TRANSFER,
    //   date: {
    //     start: new Date()
    //   },
    //   data: {
    //     transfers: [
    //           // Square Fees
    //           {
    //               srcAccount: "442829529",  // Expenses
    //               destAccount: "495280120", // Cash Revenue
    //               amount: "3.61",
    //               transactionDescription: "Square Fees"
    //           },
    //           {
    //             srcAccount: "495280120",  // Cash Revenue
    //             destAccount: "480004229", // Revenue
    //             amount: "190",
    //             transactionDescription: "Inv 1356"
    //           }
    //       ]
    //   }
    // }).subscribe(r=> {
    //   console.log(r);
    // })

  }

}